/* Layout */
import Layout from '../../views/layout/Layout.vue'

const TrendingFeedList = () => import(/* webpackChunkName: "trending-feeds" */ '@/views/trending/feed/feed-list')
const TrendingFeedDetail = () => import(/* webpackChunkName: "trending-feeds" */ '@/views/trending/feed/feed-detail')
const TrendingFeedUpload = () => import(/* webpackChunkName: "trending-feeds" */ '@/views/trending/feed/feed-upload')

export default [
  {
    path: '/trending-feeds',
    component: Layout,
    redirect: '/trending-feeds/list',
    name: 'trendingFeeds',
    alwaysShow: true,
    meta: {
      title: 'trendingFeeds',
      icon: ['fas', 'th-list'],
    },
    children: [
      {
        path: 'create',
        component: TrendingFeedDetail,
        name: 'trending-feed-create',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'trending-feed',
        },
      },


      {
        path: 'upload',
        component: TrendingFeedUpload,
        name: 'trending-feed-upload',
        meta: {
          title: 'uploadMultiple',
          icon: 'upload',
          accessibleName: 'trending-feed',
        },
      },


      {
        path: 'edit/:id',
        component: TrendingFeedDetail,
        name: 'trending-feed-edit',
        props: true,
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'trending-feed',
        },
      },
      {
        path: 'list',
        component: TrendingFeedList,
        name: 'trending-feed-list',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'trending-feed',
        },
      },
    ],
  },
]
